import React from 'react';
import SideBarContainer from './controls/sidebar/index';
import ErrorDetails from './errorDetails';

const ErrorContainer = ({error, errorDescription}) => (
    <div className='portal-main-wrapper'>
        <SideBarContainer />
        <div className='error-full-wrapper'>
            <ErrorDetails
                error={error}
                errorDescription={errorDescription}>
            </ErrorDetails>
        </div>
    </div>
);

export default ErrorContainer;


// WEBPACK FOOTER //
// ./src/components/portal/errorContainer.jsx